export default{
  setData (key, value, expired) {
    let currentTime = new Date().getTime()
    let pastTime = expired * 61 * 1000
    localStorage.setItem(key, JSON.stringify({data: value, time: currentTime + pastTime}))
  },
  getData (key) {
    try {
      let itemValue = localStorage.getItem(key)
      if (itemValue === null) {
        return ''
      }
      let dataObj = JSON.parse(itemValue)
      if (!dataObj.time) {
        return ''
      }
      if (new Date().getTime() > dataObj.time) {
        console.log('exp')
        return ''
      } else {
        return dataObj.data
      }
    } catch (error) {
      console.log('getData error ')
      return ''
    }
  },
  removeData (key) {
    localStorage.removeItem(key)
  }
}



// WEBPACK FOOTER //
// ./src/config/myLocalStorage.js